// Public routes
import { Auth } from "../pages/Authentication"
// Utils
import { PageTitles } from "../constants"
import { APP_ROUTES } from "../helpers/routeHelpers"
import { withTitle } from "../hoc"
// Super Admin / Admin
import { Faqs as AdminFaqs } from "pages/AdminApp/Faqs"
import { TopNavButtons as AdminInventory } from "pages/AdminApp/Inventory"
import { TopNavButtons as AdminInventoryRequest } from "pages/AdminApp/InventoryRequest"
import { LocationsListing as AdminLocations } from "pages/AdminApp/Locations"
import { UserManagementListing as AdminUserManagement } from "pages/AdminApp/UserManagement"
// Finance
import { TopNavButtons as GeneralOrderManagement } from "pages/FinanceApp/OrderManagement"
// Common
import { CountsheetListing } from "pages/AdminApp/Countsheet"
import { ConfiguratorSettings } from "pages/Configurator"
import { TrailerSettings } from "pages/Configurator/TrailerSettings"
import { Dashboard } from "pages/Dasboard"
import { ProductionLineManagement } from "pages/ProductionLineManagement"
import ProductionLineDetails from "pages/ProductionLineManagement/ProductionLineDetails"
import { Settings } from "pages/Settings"
import { TimelineManagement } from "pages/Timeline"
import {
   AddTrailerManagement,
   CloneTrailerManagement,
   TrailerManagementDetails,
   TrailerManagementListing,
   UpdateTrailerManagement,
} from "pages/TrailerManagement"
import { VendorManagementListing } from "pages/VendorManagement"
import VendorDetails from "pages/VendorManagement/VendorDetails"
import { UserRoles } from "../constants"
// Dont remove this import
import { InventoryManagement as FinanceInventoryManagement } from "pages/FinanceApp/InventoryManagement"
import {
   GlobalBaseFeatures,
   GlobalBaseFeaturesItems,
   GlobalEquipment,
   GlobalEquipmentCategoryItems,
   GlobalPackages,
   GlobalPackageItemsListing,
   GlobalPersonalization,
   GlobalPersonalizationCategoryItems,
   GlobalWarranty,
} from "pages/GlobalConfigurator"

const {
   Finance,
   Executive,
   SuperAdmin,
   Admin,
   PlantManager,
   AssistantPlantManager,
   FrontOffice,
} = UserRoles

export const protectedRoutes = [
   {
      path: APP_ROUTES.DASHBOARD,
      component: withTitle({
         component: Dashboard,
         title: PageTitles.DASHBOARD,
      }),
      title: PageTitles.DASHBOARD,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.INVENTORY_MANAGEMENT,
      component: withTitle({
         component: AdminInventory,
         title: PageTitles.INVENTORY_MANAGEMENT,
      }),
      title: PageTitles.INVENTORY_MANAGEMENT,
      exact: true,
      permissions: [
         Finance,
         Executive,
         SuperAdmin,
         PlantManager,
         AssistantPlantManager,
      ],
   },
   {
      path: APP_ROUTES.INVENTORY_REQUEST,
      component: withTitle({
         component: AdminInventoryRequest,
         title: PageTitles.INVENTORY_REQUEST,
      }),
      title: PageTitles.INVENTORY_REQUEST,
      exact: false,
      permissions: [Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.LOCATION,
      component: withTitle({
         component: AdminLocations,
         title: PageTitles.LOCATION,
      }),
      title: PageTitles.LOCATION,
      exact: false,
      permissions: [Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.ORDER_MANAGEMENT,
      component: withTitle({
         component: GeneralOrderManagement,
         title: PageTitles.ORDER_MANAGEMENT,
      }),
      title: PageTitles.ORDER_MANAGEMENT,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILERS,
      component: withTitle({
         component: ConfiguratorSettings,
         title: PageTitles.CONFIGURATOR_TRAILERS,
      }),
      title: PageTitles.CONFIGURATOR_TRAILERS,
      exact: false,
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS,
      component: withTitle({
         component: TrailerSettings,
         title: PageTitles.CONFIGURATOR_TRAILERS,
      }),
      title: PageTitles.CONFIGURATOR_TRAILERS,
      exact: false,
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.SETTINGS,
      component: withTitle({
         component: Settings,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_BASE_FEATURES,
      component: withTitle({
         component: GlobalBaseFeatures,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_BASE_FEATURES_ITEMS,
      component: withTitle({
         component: GlobalBaseFeaturesItems,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_PACKAGES,
      component: withTitle({
         component: GlobalPackages,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_PACKAGES_ITEMS,
      component: withTitle({
         component: GlobalPackageItemsListing,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_CUSTOMIZATION,
      component: withTitle({
         component: GlobalPersonalization,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_CUSTOMIZATION_ITEMS,
      component: withTitle({
         component: GlobalPersonalizationCategoryItems,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_EQUIPMENTS,
      component: withTitle({
         component: GlobalEquipment,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_EQUIPMENT_ITEMS,
      component: withTitle({
         component: GlobalEquipmentCategoryItems,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_WARRANTY,
      component: withTitle({
         component: GlobalWarranty,
         title: PageTitles.SETTINGS,
      }),
      title: PageTitles.SETTINGS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.USER_MANAGEMENT,
      component: withTitle({
         component: AdminUserManagement,
         title: PageTitles.USER_MANAGEMENT,
      }),
      title: PageTitles.USER_MANAGEMENT,
      exact: true,
      permissions: [SuperAdmin, PlantManager, AssistantPlantManager],
   },
   {
      path: APP_ROUTES.VENDOR_MANAGEMENT,
      component: withTitle({
         component: VendorManagementListing,
         title: PageTitles.VENDOR_MANAGEMENT,
      }),
      title: PageTitles.VENDOR_MANAGEMENT,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.VENDOR_MANAGEMENT_DETAILS,
      component: withTitle({
         component: VendorDetails,
         title: PageTitles.VENDOR_MANAGEMENT,
      }),
      title: PageTitles.VENDOR_MANAGEMENT,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.FAQS,
      component: withTitle({
         component: AdminFaqs,
         title: PageTitles.FAQS,
      }),
      title: PageTitles.FAQS,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      path: APP_ROUTES.TRAILERS_MANAGEMENT,
      component: withTitle({
         component: TrailerManagementListing,
         title: PageTitles.TRAILERS_MANAGEMENT,
      }),
      title: PageTitles.TRAILERS_MANAGEMENT,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.TRAILERS_MANAGEMENT_ADD_TRAILER,
      component: withTitle({
         component: AddTrailerManagement,
         title: PageTitles.TRAILERS_MANAGEMENT,
      }),
      title: PageTitles.TRAILERS_MANAGEMENT,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.TRAILERS_MANAGEMENT_UPDATE_TRAILER,
      component: withTitle({
         component: UpdateTrailerManagement,
         title: PageTitles.TRAILERS_MANAGEMENT,
      }),
      title: PageTitles.TRAILERS_MANAGEMENT,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.TRAILERS_MANAGEMENT_CLONE_TRAILER,
      component: withTitle({
         component: CloneTrailerManagement,
         title: PageTitles.TRAILERS_MANAGEMENT,
      }),
      title: PageTitles.TRAILERS_MANAGEMENT,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.TRAILERS_MANAGEMENT_TRAILER_DETAILS,
      component: withTitle({
         component: TrailerManagementDetails,
         title: PageTitles.TRAILERS_MANAGEMENT,
      }),
      title: PageTitles.TRAILERS_MANAGEMENT,
      exact: true,
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },

   {
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT,
      component: withTitle({
         component: ProductionLineManagement,
         title: PageTitles.PRODUCTION_LINE_MANAGEMENT,
      }),
      exact: true,
      permissions: [SuperAdmin, FrontOffice],
   },

   {
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_LISTING,
      component: withTitle({
         component: ProductionLineManagement,
         title: PageTitles.PRODUCTION_LINE_MANAGEMENT,
      }),
      exact: true,
      permissions: [SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_MOULD,
      component: withTitle({
         component: ProductionLineManagement,
         title: PageTitles.PRODUCTION_LINE_MOULDS,
      }),
      exact: true,
      permissions: [SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_DETAILS,
      component: withTitle({
         component: ProductionLineDetails,
         title: PageTitles.PRODUCTION_LINE_MANAGEMENT,
      }),
      exact: true,
      permissions: [SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_DETAILS_OVERRIDES,
      component: withTitle({
         component: ProductionLineDetails,
         title: PageTitles.PRODUCTION_LINE_MANAGEMENT,
      }),
      exact: false,
      permissions: [SuperAdmin, FrontOffice],
   },
   {
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_DETAILS_STAGES,
      component: withTitle({
         component: ProductionLineDetails,
         title: PageTitles.PRODUCTION_LINE_MANAGEMENT,
      }),
      exact: false,
      permissions: [SuperAdmin, FrontOffice],
   },

   {
      path: APP_ROUTES.TIMELINE,
      component: withTitle({
         component: TimelineManagement,
         title: PageTitles.TIMELINE,
      }),
      title: PageTitles.TIMELINE,
      exact: false,
      permissions: [
         Finance,
         Executive,
         SuperAdmin,
         PlantManager,
         AssistantPlantManager,
         FrontOffice,
      ],
   },
   {
      path: APP_ROUTES.COUNT_SHEET,
      component: withTitle({
         component: CountsheetListing,
         title: PageTitles.COUNTSHEET,
      }),
      title: PageTitles.COUNTSHEET,
      exact: false,
      permissions: [
         Executive,
         SuperAdmin,
         PlantManager,
         AssistantPlantManager,
         Finance,
      ],
   },
]

export const publicRoutes = [
   {
      path: APP_ROUTES.LOGIN,
      component: withTitle({
         component: Auth,
         title: PageTitles.LOGIN,
      }),
   },
   {
      path: APP_ROUTES.FORGET_PASSWORD,
      component: withTitle({
         component: Auth,
         title: PageTitles.FORGET_PASSWORD,
      }),
   },
   {
      path: APP_ROUTES.FORGET_VERIFY_CODE,
      component: withTitle({
         component: Auth,
         title: PageTitles.FORGET_VERIFY_CODE,
      }),
   },
   {
      path: APP_ROUTES.RESET_PASSWORD,
      component: withTitle({
         component: Auth,
         title: PageTitles.RESET_PASSWORD,
      }),
   },
]
